/* Matcha Cercle - limited-time deal countdown.
   Reads the end time from the card's data-end attribute so the date can be
   changed in the theme editor without touching this file.
   Hides the whole card once the offer has expired. */

(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function start(root) {
    var raw = root.getAttribute('data-end');
    if (!raw) return;

    var end = new Date(raw).getTime();
    if (isNaN(end)) return;

    var d = root.querySelector('[data-mc-d]');
    var h = root.querySelector('[data-mc-h]');
    var m = root.querySelector('[data-mc-m]');
    var s = root.querySelector('[data-mc-s]');
    var timer = null;

    function tick() {
      var diff = end - Date.now();

      if (diff <= 0) {
        root.style.display = 'none';
        if (timer) clearInterval(timer);
        return;
      }

      var t = Math.floor(diff / 1000);
      var dd = Math.floor(t / 86400); t -= dd * 86400;
      var hh = Math.floor(t / 3600);  t -= hh * 3600;
      var mm = Math.floor(t / 60);    t -= mm * 60;

      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(t);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init() {
    var cards = document.querySelectorAll('.mc-deal[data-end]');
    for (var i = 0; i < cards.length; i++) start(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
